import { constants } from '../config';

class Analytics {
  static injectGoogleAnalytics() {
    // NOTE: disabling eslint since this code is copy-pasted directly from Google's instructions.
    // More here: https://developers.google.com/analytics/devguides/collection/analyticsjs/
    /* eslint-disable */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    /* eslint-enable */
  }

  static startTracking() {
    const gAnalyticsId = constants.googleAnalyticsId;
    if (!gAnalyticsId) {
      return;
    }
    Analytics.injectGoogleAnalytics();

    window.ga('create', constants.googleAnalyticsId, 'auto');
    window.ga('send', 'pageview');
  }

  static sendClickTracking(category, label) {
    const gAnalyticsId = constants.googleAnalyticsId;
    if (!gAnalyticsId) {
      return;
    }
    Analytics.injectGoogleAnalytics();
    window.ga('send', 'event', category, 'click', label, 0);
  }
}

export { Analytics };



// WEBPACK FOOTER //
// ./src/helpers/Analytics.js